import axios, { AxiosResponse } from 'axios';

import UpdatePilotLineInput from 'modules/Pilot/models/UpdatePilotLineInput';

export default function updateAsync(apiUrl: string) {
  return function api<TResponse>(
    id: string | undefined | null,
    input: UpdatePilotLineInput | undefined | null
  ): Promise<AxiosResponse<TResponse>> {
    return new Promise<AxiosResponse<TResponse>>((resolve, reject) => {
      axios
        .request<TResponse>({
          url: `${apiUrl}/api/app/pilot-lines/${id}`,
          method: 'PUT',
          data: input,
        })
        .then(response => {
          if (response.status === 400) {
            reject(response);
            return;
          }
          resolve(response);
        }, reject);
    });
  };
}
